export default __webpack_public_path__ + "static/media/HistoricUser.5ad5f8e0.svg";